import { Component, OnInit } from '@angular/core';
import { ScheduleService,MasterService,PlacementService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-planotifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  providers:[ScheduleService,MasterService,PlacementService]
})
export class PlanotificationsComponent implements OnInit {

  closeResult: string;
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  arrschnote:any=[];
  mascls=[];
  massec=[];
  arrstudent=[];
  arrcourse=[];
  objschd:any={};
  discourse:boolean=false;
  disclass:boolean=false;
  dissection:boolean=false;
  disstudent:boolean=false;
  disadd:boolean=false;
  nfid:any;
  arrnoted:any=[];
  arrftype=[{name:'Url'},{name:'File'}];
  ftype:any;
  fpath:any;
  fnm:any;
  arrstudoc:any=[];
  fileToUpload: File = null;

  fData: FormData = new FormData;
  notetype=[{value:'Generic',label:'ALL'},{value:'Institute',label:'Institute Specific'},{value:'Student',label:'Student Specific'}];
  objfilt:any={};
    objsch:any={};
    arrasch:any=[];
    arrinst:any=[];

  constructor(private http: HttpClient, private pservice: PlacementService, private sservice: ScheduleService,private mservice:MasterService,private modalService: NgbModal) { }

  open(content) {
    this.modalOptions = {
     
      size:'sm'
     
    }
    this.modalService.open(content, this.modalOptions ).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
 
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit(): void {

    this.Bindtable();
    this.Getclasslist();
    this.getsection();
    this.mascourse();
  }

  getinstitute() {
    this.pservice.getinstitute()
        .subscribe(
        resultArray => {
            console.log('getinstitute', resultArray);
            this.arrinst = resultArray;
           // this.selnst=resultArray[0].id;
            //this.getcandidates(resultArray[0].id,this.status);
        },
        error => console.log("Error :: " + error)
        )
  }

  getstudent(cmd) {
    debugger
   var dbnm = '';
     var clid = this.objschd.clid;
     var secid = this.objschd.scid;
     var brid = '0';
     this.sservice.getstudents_clwise(clid, secid,1)
      .subscribe(
      resultArray => {
        console.log('std-result', resultArray);
        this.arrstudent = resultArray; 
        // if (cmd=='insert')
        // {
        // this.objschd.stuid=resultArray[0].stuid;
        // }       
      },
      error => console.log("Error :: " + error)
      );
  }

  Getclasslist() {
    var defsec={clid:'0',clnm:'ALL'};
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('class-result', resultArray);
            this.mascls = resultArray;
            //this.objfilt.clid='0';
            this.mascls.splice(0,0,defsec);
        },
        error => console.log("Error :: " + error)
        )
}


mascourse() {
  var defsec={crid:'0',crnm:'ALL'};
  this.mservice.mascourse()
      .subscribe(
      resultArray => {
          console.log('class-result', resultArray);
          this.arrcourse = resultArray;
          //this.objfilt.clid='0';
          this.arrcourse.splice(0,0,defsec);
      },
      error => console.log("Error :: " + error)
      )
}
  
getsection() {
  var defsec={scid:'0',scnm:'ALL'};
  this.mservice.massection()
      .subscribe(
      resultArray => {
          console.log('class-result', resultArray);
          this.massec = resultArray;
          
          this.massec.splice(0,0,defsec);
          //this.objsch.secid='0';
      },
      error => console.log("Error :: " + error)
      )
}


  Bindtable() {
      debugger
      
      
      this.sservice.getschnotification()
          .subscribe(resultArray => {
             console.log('ret-select', resultArray);
              this.arrschnote = resultArray;
              //alert (resultArray.message);

          }, error =>
              alert('error in connection')
          );
      
  }
 
  Bindnoted() {
    debugger
    
    
    this.sservice.getschnotd(this.nfid)
        .subscribe(resultArray => {
           console.log('ret-select', resultArray);
            this.arrnoted = resultArray;
            //alert (resultArray.message);

        }, error =>
            alert('error in connection')
        );
    
}

  opensubject(content,objdata,cmd) {
    debugger
    if(cmd=='insert')
    {
      this.objsch={};
     
      
      //console.log('date',this.sservice.getdatetoday().toString())
      this.objsch.nfscope='Generic';
      this.objsch.nfid='0';
      this.objsch.nfcontent='';
      this.objsch.nfgp='0';
      this.objsch.stuid='0';
      this.objsch.clid='0';
      this.objsch.crid='0';
      this.objsch.scid='0';
      //this.objsch.stuid='0';

      //this.objsch.subgpId=0;
      //this.objsch.holdt1=this.sservice.getdatetoday();
      
      //this.objsubject.subcaId=0;
      // this.objsubcat.subcacd='';
      //this.objsubcat.subcanm='';
      this.objsch.oprtype='i_noteh';
     
    }
  
    else if(cmd=='update')
    {
debugger
      
      this.objsch=objdata;
      this.getstudent(cmd);
      this.objsch.stuid=objdata.stuid;
      this.objsch.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
      
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  opennoted(content,objdata,cmd) {
    debugger
    this.nfid=objdata.nfid;
    this.Bindnoted();
//notetype=[{value:'Generic',label:'ALL'},{value:'Course',label:'Course Specific'},{value:'Class',label:'Class Specific'},{value:'Student',label:'Student Specific'}];
if(objdata.nfscope=="Generic")
{
  this.disclass=true;
  this.discourse=true;
  this.dissection=true;
  this.disstudent=true;

}

else if(objdata.nfscope=="Course")
{
  this.disclass=true;
  this.discourse=false;
  this.dissection=true;
  this.disstudent=true;

}
else if(objdata.nfscope=="Class")
{
  this.disclass=false;
  this.discourse=false;
  this.dissection=false;
  this.disstudent=true;

}

else if(objdata.nfscope=="Student")
{
  this.disclass=false;
  this.discourse=false;
  this.dissection=false;
  this.disstudent=false;
}

    if(cmd=='insert')
    {
      this.objschd={};
     
      
      //console.log('date',this.sservice.getdatetoday().toString())
      this.objschd.nfscope='';
      this.objschd.nfid=objdata.nfid;
      this.objschd.nfcontent='';
      this.objschd.nfgp='0';
      this.objschd.stuid='0';
      this.objschd.clid='0';
      this.objschd.crid='0';
      this.objschd.scid='0';
      
      this.objschd.oprtype='i_noted';
     
    }
  
    
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
      
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  SaveDetails() {
    
    console.log('save-model', this.objsch);
    var dbnm='';
    

    this.sservice.saveschnotification(this.objsch)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            if(resultArray.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
             // this.Getsel_sp_massubgp();
             this.Bindtable();
            }
            
  
        }, error =>
            alert('error in connection')
        );
   // this.closeAddExpenseModal.nativeElement.click();

  }


  Savenoted() {
    
    console.log('save-model', this.objschd);
    var dbnm='';
    

    this.sservice.saveschnotification(this.objschd)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            // if(resultArray.status=='success')
            // {
            //   let localmodref=this.modalRef;
            //   localmodref.close();
            //  // this.Getsel_sp_massubgp();
             
            // }
            this.Bindnoted();
  
        }, error =>
            alert('error in connection')
        );
   // this.closeAddExpenseModal.nativeElement.click();

  }
  Deletedetails(nfid) {

    if(confirm("Are you sure? you wan't to delete. "))
    {
   
   
   
    
    
   
    //console.log('save-model', clssubdata);
    this.sservice.delschnotification(nfid)
        .subscribe(resultArray => {
            console.log('ret-save', resultArray);
            
            alert (resultArray.message);
            if(resultArray.status=='success')
            {
              
             this.Bindtable();
            }
            
  
        }, error =>
            alert('error in connection')
        );
   // this.closeAddExpenseModal.nativeElement.click();
  }
}

delnoted(rid) {

  if(confirm("Are you sure? you wan't to delete. "))
  {
 
 
 
  
  
 
  //console.log('save-model', clssubdata);
  this.sservice.delnoted(rid)
      .subscribe(resultArray => {
          console.log('ret-save', resultArray);
          
          alert (resultArray.message);
          if(resultArray.status=='success')
          {
            
           this.Bindnoted();
          }
          

      }, error =>
          alert('error in connection')
      );
 // this.closeAddExpenseModal.nativeElement.click();
}
}



upload(files: FileList) {
  debugger;
  this.fileToUpload = files.item(0);

  this.fData.append("nfid", this.nfid.toString());
  this.fData.append("fpath", this.fpath.toString());
  this.fData.append("ftype", this.ftype.toString());
  //this.fData.append("docpurpose", "Studentphoto");

  // this.SService.uploadFile(fData).subscribe(
  //     response => this.handleResponse(response),
  //     error => this.handleError(error)
  // )
}

fileupload()
{
debugger

console.log('file data',JSON.stringify(this.fileToUpload));

this.sservice.uploadnoteda(this.fileToUpload,this.nfid,this.fpath,this.ftype,this.fnm)
.subscribe(fresult => {
   // console.log('ret',JSON.stringify(fresult));
    alert (fresult.message);
    if(fresult.status=='Success')
{
// let localmodref=this.modalRef;
// localmodref.close();
//this.Refreshsummary();
this.fileToUpload=null;
this.fpath='';

this.getnoteda(this.nfid);
}
    
}, error => 
alert('error in connection')

);



}

getnoteda(stuid) {
  this.sservice.getnoteda(stuid)
      .subscribe(
      resultArray => {
          console.log('arrmtongue', resultArray);
          this.arrstudoc = resultArray;
         
      },
      error => console.log("Error :: " + error)
      )
}


delnoteda(stuid) {
  if(confirm("Are you sure you wan't to delete?"))
  {
  this.sservice.delnoteda(stuid)
      .subscribe(
      resultArray => {
          console.log('arrmtongue', resultArray);
          //this.arrstudoc = resultArray;
          alert(resultArray.message);
          this.getnoteda(this.nfid);
         
      },
      error => console.log("Error :: " + error)
      )
    }
}

openlink(url){
  

  window.open(url,'','_blank');
}
openinfo(content,nfid)
{
  //this.getstudentdocs(bkid);
//this.masgeneral('Student Docs');
this.getnoteda(nfid);
  this.nfid=nfid;
  this.fpath='';
  this,this.ftype="Url";
  this.modalOptions = {
    backdrop:'static',
    backdropClass:'customBackdrop',
    size:'lg'
   }
  this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

}
